__turbopack_context__.v({
  "navButton": "cglLXq_navButton",
  "slide": "cglLXq_slide",
  "sliderContainer": "cglLXq_sliderContainer",
  "sliderContent": "cglLXq_sliderContent",
  "sliderWrapper": "cglLXq_sliderWrapper",
});
